<template>
    <div class="filter-bar">
        <div class="filter-bar-label">{{ name }}</div>
        <div class="all-wrapper" :class="{
            'is-checked': isAll
        }">
            <v-checkbox :value="isAll" @input="$emit('on-clear')">全部</v-checkbox>
        </div>
        <div class="filter-bar-content">
            <div v-if="type == 'group'" class="flex-1">
                <div v-for="item in options" class="g-row" :key="item.group">
                    <div class="sub-title">{{ item.group }}</div>
                    <div class="filter-bar-list"  :style="{height:expanded?'auto':'31px'}">
                        <div v-for="(option, index) in item.value" :key="index" class="filter-bar-item">
                            <slot name="item" :option="option" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="filter-bar-list" ref="filterRef" :style="{height:expanded?'auto':'31px'}">
                    <div v-for="(option, index) in options" :key="index" class="filter-bar-item">
                        <slot name="item" :option="option" />
                    </div>
                </div>
            </div>
        </div>
        <button v-if="canExtend && !expanded" class="more-btn" @click="expanded = true">更多<i class="ficon ficon-arrow-bottom" /></button>
    </div>
</template>

<script>
import { useElementSize } from "@vueuse/core";
import {ref} from "@nuxtjs/composition-api";

export default {
    props: {
        isAll: {
            type: Boolean,
            default: true,
        },
        name: {
            type: String,
            default: "",
        },
        options: {
            type: Array,
            default: () => [],
        },
        type: {
            type: String,
            default: 'normal'
        }
    },
    data() {
        return {
            expanded: true,
            canExtend:false
        };
    },
    setup(){
        const filterRef = ref();
        const { height } = useElementSize(filterRef);
        return {
            filterRef,
            filterHeight:height,
        }
    },
    mounted(){
        const unwatch = this.$watch('filterHeight', (val)=>{
            if(val>35){
                this.expanded = false
                this.canExtend = true
            }
            unwatch()
        })
    }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base/_color";
.filter-bar {
  line-height: 34px;
  display: flex;
  margin-right: -2px;
}
.filter-bar-label {
  float: left;
  margin-right: 34px;
  font-size: 16px;
  width: 64px;
  white-space: nowrap;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.filter-bar-content {
  display: flex;
  flex: 1;
}
.filter-bar .all-wrapper {
  margin-right: 30px;
}
.filter-bar-list {
  flex: 1;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  transition: all 0.2s;
}
.filter-bar .more-btn {
  width: 70px;
  height: 28px;
  color: #3d3d3d;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  border-radius: 2px;
  font-size: 14px;
  border: 1px solid #191919;
}
.filter-bar .more-btn .ficon {
  margin-left: 3px;
}
.filter-bar .more-btn:hover {
  color: $color-primary;
  border-color: $color-primary;
}
.filter-bar-item {
  padding: 0 10px;
  box-sizing: border-box;
}
.filter-bar ::v-deep .v-checkbox__label {
  font-size: 16px !important;
  color: #3d3d3d !important;
}
.filter-bar ::v-deep .v-checkbox__input {
  font-size: 16px;
}
.filter-bar ::v-deep .v-checkbox__input .ficon {
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.filter-bar .g-row {
  display: flex;
}
.filter-bar .sub-title {
  margin-right: 20px;
  font-size: 16px;
  padding-left: 10px;
  --tw-text-opacity: 1;
  color: rgba(151, 154, 168, var(--tw-text-opacity));
}
</style>
